import { combineReducers } from 'redux';
import { reducer as sessions } from './Sessions/index';
import { reducer as webinars } from './Webinars/index';
import { reducer as recordings } from './Recordings/index';
import { reducer as user } from './User/index';
import { reducer as reports } from './Reports/index';
import { reducer as sessionDetails } from './SessionDetails/index';
import { reducer as sessionRegistrants } from './SessionRegistrants/index';
import { reducer as sessionAttendees } from './SessionAttendees/index';
import { reducer as sessionPolls } from './SessionPoll/index';
import { reducer as sessionQuestions } from './SessionQuestions/index';
import { reducer as sessionSurveys } from './SessionSurvey/index';
import { reducer as recordingDetails } from './RecordingDetails/index';
import { reducer as VirtualEvents } from './VirtualEvents/index';
import { reducer as adminSessions } from './AdminSessions/index';
import { reducer as adminWebinars } from './AdminWebinars/index';
import { reducer as adminRecordings } from './AdminRecordings/index';

const rootReducer = combineReducers({
  reduced_sessions: sessions,
  reduced_webinars: webinars,
  reduced_recordings: recordings,
  reduced_user: user,
  reduced_reports: reports,
  reduced_session_details: sessionDetails,
  reduced_session_registrants: sessionRegistrants,
  reduced_session_attendees: sessionAttendees,
  reduced_session_polls: sessionPolls,
  reduced_session_questions: sessionQuestions,
  reduced_session_surveys: sessionSurveys,
  reduced_recording_details: recordingDetails,
  reduced_virtual_events: VirtualEvents,
  reduced_admin_sessions: adminSessions,
  reduced_admin_webinars: adminWebinars,
  reduced_admin_recordings: adminRecordings
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/Reducks/RootReducer.js